/**
 * window.postMessage를 전송합니다.
 *
 * @param {Object} payload 전달할 데이터
 * @param {Window} [target=window.opener] 메시지를 받을 대상
 * @param {string} [origin='*'] 허용 Origin
 *
 * @throws {Error}
 * 대상 Window 객체가 없는 경우
 */
export function postMessage(payload, target = window.opener, origin = window.location.origin) {
  if (!target) {
    throw new Error('메시지를 전송할 대상이 없습니다.');
  }

  target.postMessage(payload, origin);
}
